var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgClockFill = function SvgClockFill(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.5373135,29 C92.0149254,26.2017544 93,22.8947369 93,19.3333333 C93,8.64912282 84.6268659,0 74.5298506,0 C68.619403,0 63.2014927,3.05263162 60,7.37719299 C72.5597014,10.4298246 83.3955224,18.0614035 90.5373135,29 L90.5373135,29 Z M40,7.44247795 C36.5777778,2.82300895 31.4444445,0 25.3333333,0 C15.311111,0 7,8.46902661 7,19.2477876 C7,22.840708 7.97777775,25.920354 9.44444438,29 C16.5333333,17.9646018 27.2888889,10.2654867 40,7.44247795 L40,7.44247795 Z M49.5,14 C27.1886227,14 9,33.3113773 9,57 C9,80.688623 27.1886227,100 49.5,100 C71.811377,100 90,80.688623 90,57 C89.7574848,33.3113773 71.811377,14 49.5,14 Z M69,62 L45,62 L45,29 L51.0631579,29 L51.0631579,55.136 L68.7473682,55.136 L68.7473682,62 L69,62 Z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgClockFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "clock-fill.a213b222de23369b2a23c88ae7c17e01.svg";